/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  getDocs,
  collection,
  query,
  where,
} from "firebase/firestore";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { db } from "../../firebase";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Form from "react-bootstrap/Form";
import usePagination from "../../components/helper/paginate/Pagination";
import "../../components/orders/DataTableTemplatingDemo/DataTableDemo.css";
import { Link, useNavigate } from "react-router-dom";
import { ComponentToPrint } from "../../components/orders/DataTableTemplatingDemo/ComponentToPrint";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { fetchDate } from "../../utils/globleFunc";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import "moment/locale/ar";
import "moment/locale/fr";
import apicache from "../../components/clearCach/clear";
import { PDFDocument } from "pdf-lib";
import html2pdf from "html2pdf.js";
import { Menu, Dropdown, message, Input } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  getArabicStatusByIdZimou,
  traduireStatutMaystro,
  translateCompanyDeliveryStatusEcotrack,
} from "../../utils/statusTranslation";
import { useTranslation } from "react-i18next";
import useIsDark from "../../utils/isDark";
import { Edit } from "lucide-react";
const DataTableTemplatingDemo = ({
  filter,
  orders,
  pageSize,
  setData,
  setLgShow,
}) => {
  const { t, i18n } = useTranslation(); // Initialize useTranslation hook
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const productdata = useSelector((state) => state.ProductsReducer);
  const [expandedRows, setExpandedRows] = useState(null);
  const [chargement, setChargement] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  let [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const count = Math.ceil(orders.length / PER_PAGE);
  const _DATA = usePagination(orders, PER_PAGE);
  const products = useSelector((state) => state.ProductsReducer);
  const [showSubmenus, setShowSubmenus] = useState({});
  const isDark = useIsDark();
  const isRTL = i18n.dir();

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const [errorMessage, setErrorMessage] = useState("");
  const [currentDate, setCurrentDate] = useState("");

  const SYNC_INTERVAL = 30 * 60 * 1000; // 30 minutes

  const runSync = async (forced = false) => {
    const lastSync = localStorage.getItem("ecotrack_last_sync");
    const now = Date.now();

    if (forced || !lastSync || now - parseInt(lastSync) > SYNC_INTERVAL) {
      console.log("⏳ Synchronisation en cours...");
      await EchotrackOrders();
      localStorage.setItem("ecotrack_last_sync", now.toString());
      await updateStatusesFromLocalStorage();
    } else {
      console.log("⏹️ Synchronisation ignorée (encore récente)");
    }
  };

  useEffect(() => {
    runSync();
  }, []);

  const EchotrackOrders = async () => {
    let page = 1;
    let lastPage = 1;
    const allOrders = [];

    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 7);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const startStr = formatDate(startDate);
    const endStr = formatDate(endDate);

    do {
      const response = await fetch(
        `${store.Uecotrack}/api/v1/get/orders?page=${page}&start_date=${startStr}&end_date=${endStr}`,
        {
          headers: {
            Authorization: `Bearer ${store.Ecotrack}`,
          },
        },
      );

      const result = await response.json();
      allOrders.push(...result.data);

      lastPage = result.last_page;
      page++;
    } while (page <= lastPage);
    localStorage.setItem("ecotrack_orders", JSON.stringify(allOrders));
    localStorage.setItem("ecotrack_last_sync", Date.now().toString());
  };

  const updateStatusesFromLocalStorage = async () => {
    try {
      const cached = localStorage.getItem("ecotrack_orders");

      if (!cached) {
        console.warn("Aucune donnée Ecotrack trouvée dans le localStorage.");
        return;
      }
      const ecotrackOrders = JSON.parse(cached);
      for (const apiOrder of ecotrackOrders) {
        const { tracking, status } = apiOrder;
        const ordersRef = collection(db, "orders");
        const q = query(
          ordersRef,
          where("user", "==", account.user),
          where("tracking", "==", tracking),
        );
        const snapshot = await getDocs(q);

        snapshot.forEach(async (docSnap) => {
          const orderData = docSnap.data();
          if (orderData.CompanyDeleveryStatus !== status) {
            const orderDocRef = doc(db, "orders", docSnap.id);
            await updateDoc(orderDocRef, {
              CompanyDeleveryStatus: status,
              deleveryStatusType: "Echotrack",
            });

            console.log(`Mis à jour : ${tracking} → ${status}`);
          } else {
            console.log(`Inchangé : ${tracking}`);
          }
        });
      }
    } catch (error) {
      console.error("❌ Erreur lors de la mise à jour des statuts :", error);
    }
  };

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();

    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      if (now.getHours() === 0 && now.getMinutes() <= 1) {
        orders.forEach((order) => {
          checkAndUpdateStatusAtMidnight(order);
        });
      }
    }, 3600000);

    return () => clearInterval(interval);
  }, [orders]);
  const darkModeStyles = `
  /* Styles pour le mode sombre du DataTable */
  .dark .p-datatable .p-datatable-thead > tr > th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr > td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }


  /* Pour les bordures du tableau */
  .dark .p-datatable {
    border-color: #3c3a3d !important;
  }

  /* Pour les éléments expandables */
  .dark .p-datatable .p-row-expansion {
    background-color: #141414 !important;
    color: #d1d5db !important;
  }
`;

  const syncCompany = async () => {
    setChargement(true);
    console.log("🚀 Début de la synchronisation globale...");

    // ZR EXPRESS
    if (store.Zrexpress && store.ZrexpressC) {
      const zrOrders = orders.filter(
        (item) => item.tracking && item.DC === "2",
      );
      const zrPayload = {
        token: store.Zrexpress,
        key: store.ZrexpressC,
        colis: zrOrders.map((item) => ({ Tracking: item.tracking })),
      };

      try {
        const response = await fetch(
          "https://backend.foorweb.shop/api/lire-zr",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(zrPayload),
          },
        );

        const data = await response.json();
        const updatedColis = data.data.Colis;

        for (const colis of updatedColis) {
          const order = zrOrders.find((o) => o.tracking === colis.Tracking);

          if (order && order.CompanyDeleveryStatus !== colis.Situation) {
            await setDoc(
              doc(db, "orders", order.id),
              {
                CompanyDeleveryStatus: colis.Situation,
                deleveryStatusType: "Zrexpress",
              },
              { merge: true },
            );
          }
        }
        console.log("✅ ZR Express terminé");
      } catch (error) {
        console.error("❌ ZR Express :", error);
      }
    }

    // ECOTRACK
    if (store.Uecotrack && store.Ecotrack) {
      const ecoOrders = orders.filter(
        (item) => item.tracking && item.DC === "3",
      );
      const formatDate = (date) => date.toISOString().split("T")[0];
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 7);

      const startStr = formatDate(startDate);
      const endStr = formatDate(endDate);

      let page = 1;
      let lastPage = 1;
      const allEcoOrders = [];

      try {
        do {
          const response = await fetch(
            `${store.Uecotrack}/api/v1/get/orders?page=${page}&start_date=${startStr}&end_date=${endStr}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${store.Ecotrack}`,
                "Content-Type": "application/json",
              },
            },
          );

          const result = await response.json();
          const commandes = result.data;

          if (!Array.isArray(commandes) || commandes.length === 0) break;

          allEcoOrders.push(...commandes);
          lastPage = result.last_page || 1;
          page++;
        } while (page <= lastPage);

        for (const item of allEcoOrders) {
          const order = ecoOrders.find((o) => o.tracking === item.tracking);

          if (order && order.CompanyDeleveryStatus !== item.status) {
            await setDoc(
              doc(db, "orders", order.id),
              {
                CompanyDeleveryStatus: item.status,
                deleveryStatusType: "Ecotrack",
              },
              { merge: true },
            );
          }
        }
        console.log("✅ Ecotrack terminé");
      } catch (error) {
        console.error("❌ Ecotrack :", error);
      }
    }

    // ZIMOU
    if (store.zimouToken && store.zimouUrl) {
      const zimouOrders = orders.filter(
        (item) => item.tracking && item.DC === "8",
      );

      try {
        const response = await fetch(
          `${store.zimouUrl}/api2/v2/orders?include=wilaya,commune,products,assigned_users,delivery_type`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${store.zimouToken}`,
            },
          },
        );

        const result = await response.json();
        const commandes = result.data;

        for (const item of commandes) {
          const order = zimouOrders.find(
            (o) => o.tracking === item.tracking_code,
          );

          if (order && order.CompanyDeleveryStatus !== item.status_name) {
            await setDoc(
              doc(db, "orders", order.id),
              {
                CompanyDeleveryStatus: item.status_name,
                deleveryStatusType: "Zimou",
              },
              { merge: true },
            );
          }
        }
        console.log("✅ Zimou terminé");
      } catch (error) {
        console.error("❌ Zimou :", error);
      }
    }

    // MAYSTRO
    if (store.Maystro) {
      const maystroOrders = orders.filter(
        (item) => item.tracking && item.DC === "1" && item.MaystroId,
      );
      const results = [];

      try {
        for (const order of maystroOrders) {
          const response = await fetch(
            `https://orders-management-dev.maystro-delivery.com/api/stores/history_order/${order.MaystroId}`,
            {
              method: "GET",
              headers: {
                Authorization: `Token ${store.Maystro}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error(
              `Erreur pour la commande ${order.id} - HTTP ${response.status}`,
            );
          }

          const history = await response.json();
          results.push({ order, history });
        }

        for (const item of results) {
          const { order, history } = item;

          if (Array.isArray(history) && history.length > 0) {
            const last = history[history.length - 1];
            await setDoc(
              doc(db, "orders", order.id),
              {
                CompanyDeleveryStatus: last.status,
                deleveryStatusType: "Maystro",
              },
              { merge: true },
            );
          }
        }
        console.log("✅ Maystro terminé");
      } catch (error) {
        console.error("❌ Maystro :", error);
      }
    }

    // YALIDINE
    if (store.Yalidineid && store.Yalidinetoken) {
      const yalidineOrders = orders.filter(
        (item) => item.tracking && item.DC === "5",
      );

      const trackingCodes = yalidineOrders.map((item) => item.tracking);
      const trackingsParam = trackingCodes.join(",");

      try {
        const response = await fetch(
          `https://backend.foorweb.shop/api/YalidineUpdate?id=${
            store.Yalidineid
          }&token=${store.Yalidinetoken}&trackings=${encodeURIComponent(
            trackingsParam,
          )}`,
        );

        const result = await response.json();
        const parcels = result.data;

        for (const order of yalidineOrders) {
          const match = parcels.find(
            (parcel) => parcel.tracking === order.tracking,
          );

          if (match) {
            await setDoc(
              doc(db, "orders", order.id),
              {
                CompanyDeleveryStatus: match.last_status,
                deleveryStatusType: "Yalidine",
              },
              { merge: true },
            );
          }
        }

        console.log("✅ Yalidine terminé");
      } catch (error) {
        console.error("❌ Yalidine frontend :", error);
      }
    }

    // Guepex
    if (store.UserguidGuepex && store.Apitokenguepex) {
      const yalidineOrders = orders.filter(
        (item) => item.tracking && item.DC === "6",
      );

      const trackingCodes = yalidineOrders.map((item) => item.tracking);
      const trackingsParam = trackingCodes.join(",");

      try {
        const response = await fetch(
          `https://backend.foorweb.shop/api/YalidineUpdate?id=${
            store.UserguidGuepex
          }&token=${store.Apitokenguepex}&trackings=${encodeURIComponent(
            trackingsParam,
          )}`,
        );

        const result = await response.json();
        const parcels = result.data;

        for (const order of yalidineOrders) {
          const match = parcels.find(
            (parcel) => parcel.tracking === order.tracking,
          );

          if (match) {
            await setDoc(
              doc(db, "orders", order.id),
              {
                CompanyDeleveryStatus: match.last_status,
                deleveryStatusType: "Guepex",
              },
              { merge: true },
            );
          }
        }

        console.log("✅ Guepex terminé");
      } catch (error) {
        console.error("❌ Guepex frontend :", error);
      }
    }

    setChargement(false);
    Swal.fire({
      icon: "success",
      title: t("ship.success_order_status_update"),
      text: t("ship.success_order_status_message"),
      confirmButtonText: t("ship.ok"),
      confirmButtonColor: "#7e5395",
      timer: 3000,
      timerProgressBar: true,
      position: "bottom-end",
      toast: true,
      showConfirmButton: false,
    });
  };

  moment.defineLocale("fr-num", {
    parentLocale: "fr",
    months: moment.locales("fr").months,
    monthsShort: moment.locales("fr").monthsShort,
    weekdays: moment.locales("fr").weekdays,
    weekdaysShort: moment.locales("fr").weekdaysShort,
    weekdaysMin: moment.locales("fr").weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
    relativeTime: {
      future: t("relative_time.future"),
      past: t("relative_time.past"),
      s: t("relative_time.s"),
      ss: t("relative_time.ss"),
      m: t("relative_time.m"),
      mm: t("relative_time.mm"),
      h: t("relative_time.h"),
      hh: t("relative_time.hh"),
      d: t("relative_time.d"),
      dd: t("relative_time.dd"),
      M: t("relative_time.M"),
      MM: t("relative_time.MM"),
      y: t("relative_time.y"),
      yy: t("relative_time.yy"),
    },
    preparse: function (string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(match);
      });
    },
  });

  useEffect(() => {
    if (errorMessage) {
      Swal.fire({
        title: t("ship.error"),
        text: errorMessage,
        icon: "error",
        confirmButtonText: t("ship.ok"),
      }).then(() => {
        setErrorMessage("");
      });
    }
  }, [errorMessage, t]);

  const dateBodyTemplate = (rowData) => {
    const timestamp = rowData.timeStamp?.seconds * 1000;
    const now = Date.now();
    const date = moment(timestamp).locale(
      i18n.language === "fr" ? "fr-num" : i18n.language,
    );
    const diff = now - timestamp;

    if (diff < 60000) {
      return (
        <span>
          {t("ship.since_seconds", { seconds: Math.floor(diff / 1000) })}
        </span>
      );
    } else if (diff < 3600000) {
      return (
        <span>
          {t("ship.since_minutes", { minutes: Math.floor(diff / 60000) })}
        </span>
      );
    } else if (diff < 86400000) {
      return (
        <span>
          {t("ship.since_hours", { hours: Math.floor(diff / 3600000) })}
        </span>
      );
    } else if (diff < 604800000) {
      return (
        <span>
          {t("ship.since_days", { days: Math.floor(diff / 86400000) })}
        </span>
      );
    } else if (diff < 604800000 + 86400000) {
      return <span>{t("ship.since_week")}</span>;
    } else {
      return <span>{date.format("YYYY-MM-DD, H:mm:ss")}</span>;
    }
  };

  const deleveryBodyTemplate = (rowData) => {
    const dc = rowData.DC;
    const deliveryCompanies = {
      3: { src: "/ecotrackk.png", alt: "Ecotrack" },
      1: { src: "/maystro.jpg", alt: "maystro" },
      8: { src: "/zimou2.png", alt: "zimou" },
      5: { src: "/yalidine2.png", alt: "yalidine" },
      2: { src: "/zrexpress2.jpg", alt: "zr express" },
      6: { src: "/geupex2.png", alt: "geupex" },
      4: { src: "/nordEtOeust.png", alt: "nord et ouest" },
      7: { src: "/Elogistia.png", alt: "Elogistia" },
      11: { src: "/yalitec.jpg", alt: "yalitec" },
      12: { src: "/colivraison.jpg", alt: "colivraison" },
      13: { src: "/mylerzzz.png", alt: "mylerz" },
    };

    const company = deliveryCompanies[dc];
    if (company) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={company.src}
            alt={company.alt}
            width={32}
            height={32}
            style={{ borderRadius: "6px" }}
          />
        </div>
      );
    }
    return null;
  };

  const orderTotal = (rowData) => {
    return (
      <span
        className="
        bg-[#faf1ff] text-[#9e68ba] px-3 py-1 rounded-lg
        dark:bg-[#2b2230] dark:text-[#d3b4e6]
      "
      >
        {rowData.total} {store.currencySymbol}
      </span>
    );
  };

  const customerName = (rowData) => {
    return (
      <Link
        style={{ textDecoration: "none" }}
        to={`/orders/details`}
        state={{
          from: { ...rowData },
          product: productdata.filter(
            (product) => product.id === rowData.productId,
          )[0],
          products: productdata,
        }}
      >
        {rowData.name}
      </Link>
    );
  };

  const maxChars = 25;
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  const changeStatus = async (data, status) => {
    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(data.statusTimeline || []),
      { status, timestamp: currentTime, ownby: account.name },
    ];
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    const truncatedProductName = truncateText(
      data.nameproduct ? data.nameproduct : product.name,
      maxChars,
    );

    const statusMessages = {
      5: store.done
        ? t("ship.status_completed", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      3: store.confrim
        ? t("ship.status_confirmed", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      9: store.confrim
        ? t("ship.status_confirmed_customer", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      1: store.new
        ? t("ship.status_new", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      4: store.delevery
        ? t("ship.status_delivered_company", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      6: store.cancel
        ? t("ship.status_canceled", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      "11-2": store.termine
        ? t("ship.status_not_answered", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      "11-3": store.termine
        ? t("ship.status_postponed", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      "11-5": store.termine
        ? t("ship.status_canceled_customer", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      "11-1": store.termine
        ? t("ship.status_awaiting_customer", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
      "11-4": store.termine
        ? t("ship.status_line_closed", {
            name: data.name,
            phone: data.phone,
            state: data.state,
            product: truncatedProductName,
          })
        : null,
    };

    const message = statusMessages[status];
    const messageC = t("ship.status_incomplete", {
      name: data.name,
      phone: "********",
      state: data.state,
      product: truncatedProductName,
    });

    await setDoc(doc(db, "orders", data.id), {
      ...data,
      deleveryStatus: status,
      statusTimeline: updatedStatusTimeline,
      ownby: account.name,
    });

    axios
      .post(`https://api.telegram.org/bot${telegramBotToken}/sendMessage`, {
        chat_id: chatId,
        text: data.isValid ? messageC : message,
      })
      .then(() => {
        console.log("تم إرسال الإشعار بنجاح");
      })
      .catch((error) => {
        console.error("حدث خطأ أثناء إرسال الإشعار", error);
      });
  };

  const rowExpansionTemplate = (data) => {
    const addIpToAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_block"),
        text: t("orderDetails.alerts.block.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("ship.confirm_block_button"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayUnion(data.ipAddress),
              });
              apicache(account, products);
              Swal.fire(t("ship.block_success"), ". تم حظر عنوان الايبي بنجاح", "success");
            } catch (error) {
              console.error("Error adding الايبي: ", error);
              Swal.fire(t("ship.error"), ". حدث خطأ أثناء حظر عنوان الايبي", "error");
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(t("ship.error"), ". لا يوجد عنوان الايبي في الطلب", "error");
          }
        }
      });
    };
    const toggleSubmenu = (productId) => {
      setShowSubmenus((prevShowSubmenus) => ({
        ...prevShowSubmenus,
        [productId]: !prevShowSubmenus[productId],
      }));
    };
    const onDelete = async (product) => {
      try {
        const orderRef = doc(db, "orders", data.id); // استبدل "وثيقة_طلبك" بمعرف الوثيقة الفعلي
        await updateDoc(orderRef, {
          products: arrayRemove(product), // استخدم الكائن الكامل للحذف
        });
      } catch (e) {
        console.error("خطأ عند حذف المنتج: ", e);
      }
    };
    const removeIpFromAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_delete"),
        text: t("orderDetails.alerts.unblock.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("orderDetails.alerts.unblock.confirm"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayRemove(data.ipAddress),
              });
              Swal.fire(t("ship.delete_success"), ". تم حذف عنوان الايبي بنجاح", "success");
            } catch (error) {
              console.error("Error removing الايبي: ", error);
              Swal.fire(t("ship.error"), ". حدث خطأ أثناء حذف عنوان الايبي", "error");
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(t("ship.error"), ". لا يوجد عنوان الايبي في الطلب", "error");
          }
        }
      });
    };
    const timestamp = data.timeStamp;
    const date = new Date(timestamp.seconds * 1000); // تحويل ثواني الوقت إلى مللي ثواني وإنشاء كائن التاريخ
    const formattedDate = date.toLocaleString();
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    let productsToShow = [];
    if (data.products && data.products.length > 0) {
      productsToShow = data.products.map((p) =>
        productdata.find((product) => product.id === p.id),
      );
    }
    return (
      <div className="orders-subtable row">
        <div className="max-w-2xl mx-auto py-0 md:px-8">
          {data.nameproduct ? (
            <>
              {data.products ? (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between dark:!border-[#3c3a3d] w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total - data.deliveryPrice}{" "}
                          {store.currencySymbol}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              ) : (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total - data.deliveryPrice}{" "}
                          {store.currencySymbol}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              )}
            </>
          ) : data.products ? (
            <ul>
              {data?.nameproduct
                ? productsToShow.map((product) => (
                    <div
                      className="max-w-2xl mx-auto py-0 md:px-8"
                      key={product?.id}
                    >
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product?.image
                                ? product?.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product?.name}
                          </div>
                          <span className="text-sm">
                            {product?.price} {store.currencySymbol}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))
                : data.products.map((product, index) => (
                    <div className="max-w-2xl mx-auto py-0 md:px-8">
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product.image
                                ? product.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product.name}
                          </div>
                          <span className="text-sm">
                            {data.total - data.deliveryPrice}{" "}
                            {store.currencySymbol}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))}
            </ul>
          ) : (
            <ul>
              <div className="d-flex justify-content-between w-100 p-1-2 border4">
                <li className="flex gap-4 items-center">
                  <img
                    src={product ? product.image : "/product-foorweb.png"}
                    className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                  />
                  <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                    {product ? product.name : ""}
                  </div>
                  <span className="text-sm">
                    {data.total} {store.currencySymbol}
                  </span>
                </li>
              </div>
            </ul>
          )}
        </div>

        <div className="mt-2 dark:text-gray-300">
          <p className="text-gray-600 text-sm font-semibold sm:text-xs dark:text-gray-300">
            {t("orders.datatable_templating_demo.order_status_updates")}:
          </p>
          <div
            className="flex items-center"
            style={{ overflowX: "auto", whiteSpace: "nowrap" }}
          >
            {data.statusTimeline ? (
              data.statusTimeline.map((statusUpdate, idx, array) => {
                const isFirstItem = idx === 0;
                return (
                  <div
                    key={idx}
                    className={`flex items-center dark:text-gray-300 ${
                      !isFirstItem ? "ml-2" : ""
                    }`}
                  >
                    {!isFirstItem && (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/3575/3575967.png"
                        alt=""
                        className="w-4 h-4"
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                      />
                    )}
                    <img
                      src={
                        statusUpdate.status === "1"
                          ? "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                          : statusUpdate.status === "2"
                            ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                            : statusUpdate.status === "9"
                              ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                              : statusUpdate.status === "3"
                                ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                : statusUpdate.status === "4"
                                  ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                                  : statusUpdate.status === "5"
                                    ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                    : statusUpdate.status === "6"
                                      ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                                      : statusUpdate.status === "11-1"
                                        ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                                        : statusUpdate.status === "11-2"
                                          ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                                          : statusUpdate.status === "11-3"
                                            ? "../agenda.png"
                                            : statusUpdate.status === "11-4"
                                              ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                                              : statusUpdate.status === "11-5"
                                                ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                                                : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png"
                      }
                      className="w-10 h-10"
                      alt=""
                    />
                  </div>
                );
              })
            ) : (
              <p className="text-gray-700 text-center dark:text-gray-400 mx-auto">
                {t("orders.datatable_templating_demo.no_Update")}
              </p>
            )}
          </div>
        </div>
        <div>
          <h4 className=" font-semibold sm:text-lg dark:text-gray-300">
            {t("orders.datatable_templating_demo.receive_order")}
          </h4>
          <p className="text-[#9e68ba]">{formattedDate}</p>
        </div>
        <div className="mt-2 grid gap-8 sm:grid-cols-2 lg:grid-cols-2">
          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_name")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>{data.name}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.phone_number")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {" "}
                  {data.isValid ? (
                    <i className="fs-3" onClick={() => handlePay(data)}>
                      <img src={"/lock.png"} className="mx-auto" />
                    </i>
                  ) : (
                    <a
                      href={`tel:${data.phone}}`}
                      style={{ textDecoration: "none" }}
                    >
                      {data.phone}
                    </a>
                  )}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_address")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.state}.{data.commune}.{data.address}{" "}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.customer_note")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data?.note?.trim() !== "" || data?.options?.trim() !== ""
                    ? data?.note?.trim() || data?.options?.trim()
                    : t("orders.datatable_templating_demo.no_note")}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.ip_address")} :
              </p>
              <p className="m-0 text-success">
                <b>{data.ipAddress ? data.ipAddress : "-"}</b>
              </p>
            </div>
          </div>

          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.product_value")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total -
                    (data.deleveryPrice
                      ? data.deleveryPrice
                      : data.deliveryPrice)}{" "}
                  {store.currencySymbol}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.quantity")} :
              </p>
              <p className="m-0 text-success">
                <b> {data.qty} </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.delivery_fees")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.deleveryPrice ? data.deleveryPrice : data.deliveryPrice}{" "}
                  {store.currencySymbol}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.grand_total")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total} {store.currencySymbol}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => addIpToAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.block")}
              </button>
              <button
                type="button"
                className="btn btn-outline-warning"
                onClick={() => removeIpFromAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.delete")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete_order"),
      html: `
        <p>${t("ship.delete_order_prompt")}</p>
        <small style="display:block;margin-top:10px;color:gray;">
          ${t("ship.delete_order_warning")}
        </small>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then((result) => {
      if (result.isConfirmed) {
        const audio = new Audio("/Mouth woosh_42.wav");
        audio.play();

        if (data.deleveryStatus === "8") {
          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleted: 1,
          }).then();
        } else {
          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "8",
          }).then();
        }
      }
    });
  };

  const navigate = useNavigate();

  const navigateToOrder = (rowData) => {
    if (rowData && rowData.id) {
      navigate(`/orderProfile/${rowData.id}`, {
        state: {
          orderData: rowData,
          productData: productdata.find(
            (product) => product.id === rowData.productId,
          ),
        },
      });
    } else {
      console.error("Order ID not found!");
    }
  };

  const handleUpdate = async (rowData) => {
    setData(rowData);
    setLgShow(true);
  };

  const actionTemplate = (rowData) => {
    return (
      <Dropdown
        overlay={
          <Menu className="">
            <Menu.Item
              key="1"
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi "
              size={16}
              onClick={
                !!account.store
                  ? () => handleUpdate(rowData)
                  : () => {
                      message();
                    }
              }
            >
              <i
                style={{
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-file-pen-line hover:text-green-500 ml-2"
                >
                  <path d="m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" />
                  <path d="M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
                  <path d="M8 18h1" />
                </svg>
                {t("orders.datatable_templating_demo.edit")}
              </i>
            </Menu.Item>
            <Menu.Item
              key={rowData.id}
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss  hover:text-green-500"
              size={16}
              onClick={() => navigateToOrder(rowData)} // Pass the entire rowData
            >
              <i
                style={{
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-eye ml-2 hover:text-green-500"
                >
                  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                {t("orders.datatable_templating_demo.preview")}
              </i>
            </Menu.Item>

            <Menu.Item
              key="3"
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 "
              size={16}
              onClick={
                !!account.store
                  ? () => {
                      handleDelete(rowData);
                    }
                  : () => {
                      message();
                    }
              }
            >
              <i
                style={{
                  color: "#f21919",
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f21919"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="lucide lucide-trash2-icon lucide-trash-2 ml-2"
                >
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                  <line x1="10" x2="10" y1="11" y2="17" />
                  <line x1="14" x2="14" y1="11" y2="17" />
                </svg>
                {t("orders.datatable_templating_demo.delete")}
              </i>
            </Menu.Item>
          </Menu>
        }
      >
        <button className="bot1 dark:bg-[#181919] dark:!text-gray-300 p-2">
          <Edit className="w-5 h-5" />
        </button>
      </Dropdown>
    );
  };

  const selectTemplate = (rowData) => {
    return (
      <div>
        <Form.Check
          type={"checkbox"}
          checked={selectedProducts.map((p) => p.id).includes(rowData.id)}
          onChange={() => {
            !selectedProducts.map((p) => p.id).includes(rowData.id)
              ? setSelectedProducts([...selectedProducts, rowData])
              : setSelectedProducts(
                  selectedProducts.filter((p) => p.id !== rowData.id),
                );
          }}
        />
      </div>
    );
  };

  const [fallbackProducts, setFallbackProducts] = useState([]);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const htmlToPdfBytes = async (element) => {
    return new Promise((resolve) => {
      const opt = {
        margin: 0,
        filename: "fallback.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .set(opt)
        .from(element)
        .outputPdf("arraybuffer")
        .then((pdfBytes) => {
          resolve(pdfBytes);
        });
    });
  };

  const handleDownloadAndPrintLabels = async () => {
    const mergedPdf = await PDFDocument.create();
    const apiPrintedTrackings = new Set();

    for (const product of selectedProducts) {
      try {
        let response;

        switch (product.DC) {
          case "3":
            response = await fetch(
              `${store?.Uecotrack}/api/v1/get/order/label?tracking=${product.tracking}`,
              {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${store?.Ecotrack}`,
                },
              },
            );
            break;

          case "1":
            const ord = JSON.stringify({
              orders_ids: [product.display_id_order || product.tracking],
            });

            response = await fetch(
              "https://backend.maystro-delivery.com/api/delivery/starter/starter_bordureau/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Token ${store?.Maystro}`,
                },
                body: ord,
              },
            );
            break;

          default:
            const transformed = {
              data: [
                {
                  tracking: product.tracking || "",
                  weight: product.weight || "1.0",
                  stopdeskDelivery: product.stopdeskDelivery,
                  total: product.total,
                  name: product.name,
                  phone: product.isValid ? "**********" : product.phone,
                  state: product.state,
                  commune: product.commune,
                  address: product.address || t("ship.not_specified"),
                  qty: product.qty,
                  productId: product.products?.[0]?.id || product.id,
                  deliveryPrice: product.deliveryPrice,
                  nameproduct:
                    product.products?.[0]?.name || t("ship.not_specified"),
                },
              ],
              account: {
                name: account.name,
                phone: account.phone,
              },
              logo: store.logo,
              products:
                product.products?.map((p) => ({
                  id: p.id,
                  name: p.name,
                  size: p.options?.size || "",
                  color: p.options?.color || "",
                })) || [],
            };
            //droplet digital ocean not off
            response = await fetch(
              "https://backend.foorweb.store/api/createPdf",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(transformed, null, 2),
              },
            );
            break;
        }

        if (!response || !response.ok) {
          console.error(
            `Erreur HTTP ${response?.status} pour ${product.tracking}`,
          );
          continue;
        }

        const pdfBytes = await response.arrayBuffer();
        const singlePdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(
          singlePdf,
          singlePdf.getPageIndices(),
        );
        copiedPages.forEach((page) => mergedPdf.addPage(page));

        apiPrintedTrackings.add(product.tracking);
      } catch (error) {
        console.error(`Erreur produit ${product.tracking} :`, error);
        continue;
      }
    }

    const mergedPdfBytes = await mergedPdf.save();
    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
    const blobURL = URL.createObjectURL(blob);

    const iframe = document.getElementById("pdfPrinter");
    if (iframe) {
      iframe.src = blobURL;
      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    } else {
      console.error("Iframe pdfPrinter introuvable dans le DOM.");
    }
  };

  const handleLabels = async () => {
    handleDownloadAndPrintLabels();
  };

  let isFunctionRunning = false;

  const handlePay = async (rowData) => {
    if (isFunctionRunning) {
      return;
    }

    isFunctionRunning = true;

    const isOnline = navigator.onLine;

    if (!isOnline) {
      Swal.fire({
        icon: "error",
        title: t("ship.no_internet"),
        text: t("ship.no_internet_message"),
        confirmButtonText: t("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false;
      return;
    }

    if (
      account.subscription.tokens > 0 ||
      account.subscription.endDate.seconds > currentDate
    ) {
      setDoc(doc(db, "account", account.id), {
        ...account,
        subscription: !(account.subscription.endDate.seconds > currentDate)
          ? { ...account.subscription, tokens: account.subscription.tokens - 1 }
          : { ...account.subscription },
      }).then(
        updateDoc(doc(db, "orders", rowData?.id), {
          isValid: false,
        }).then(() => {
          isFunctionRunning = false;
        }),
      );
    } else {
      Swal.fire({
        icon: "error",
        title: t("ship.insufficient_balance"),
        text: t("ship.insufficient_balance_message"),
        confirmButtonText: t("ship.recharge_balance"),
        confirmButtonColor: "rgb(141, 93, 167)",
        showCancelButton: true,
        cancelButtonText: t("ship.cancel_button"),
        cancelButtonColor: "#e87778",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/plan";
        }
        isFunctionRunning = false;
      });
    }
  };

  const notPaidTemplate = (rowData) => {
    const handleCopyPhone = async (phone, event) => {
      const showSuccessNotification = (targetElement) => {
        const rect = targetElement.getBoundingClientRect();

        const successMsg = document.createElement("div");
        successMsg.innerHTML = t("ship.copy_success");
        successMsg.style.cssText = `
          position: fixed;
          top: ${rect.bottom + 10}px;
          left: ${rect.left + rect.width / 2}px;
          transform: translateX(-50%);
          background: linear-gradient(135deg, #4CAF50, #45a049);
          color: white;
          padding: 12px 20px;
          border-radius: 25px;
          font-size: 14px;
          font-weight: bold;
          z-index: 50;
          direction: ${i18n.language === "ar" ? "rtl" : "ltr"};
          font-family: Arial, sans-serif;
          box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
          border: 2px solid rgba(255, 255, 255, 0.3);
          animation: copySuccess 0.6s ease-out;
          white-space: nowrap;
        `;

        if (!document.getElementById("copy-success-animation")) {
          const style = document.createElement("style");
          style.id = "copy-success-animation";
          style.textContent = `
            @keyframes copySuccess {
              0% { opacity: 0; transform: translateX(-50%) translateY(-10px) scale(0.8); }
              50% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1.05); }
              100% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
            }
            @keyframes copyFadeOut {
              0% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
              100% { opacity: 0; transform: translateX(-50%) translateY(-10px) scale(0.9); }
            }
          `;
          document.head.appendChild(style);
        }

        document.body.appendChild(successMsg);

        setTimeout(() => {
          successMsg.style.animation = "copyFadeOut 0.3s ease-in forwards";
          setTimeout(() => {
            if (document.body.contains(successMsg)) {
              document.body.removeChild(successMsg);
            }
          }, 300);
        }, 1700);
      };

      try {
        await navigator.clipboard.writeText(phone);
        showSuccessNotification(event.target);
      } catch (err) {
        console.error("Failed to copy: ", err);
        const textArea = document.createElement("textarea");
        textArea.value = phone;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        showSuccessNotification(event.target);
      }
    };

    return (
      <div>
        {rowData.isValid ? (
          <i className="fs-3" onClick={() => handlePay(rowData)}>
            <img src={"/lock.png"} className="mx-auto" />
          </i>
        ) : (
          <span
            style={{
              textDecoration: "none",
              color: "#007bff",
              cursor: "pointer",
            }}
            onClick={(e) => handleCopyPhone(rowData.phone, e)}
            title={t("ship.click_to_copy")}
          >
            {rowData.phone}
          </span>
        )}
      </div>
    );
  };

  const wilaya1 = (rowData) => {
    return (
      <div>
        <a style={{ textDecoration: "none" }}>{rowData.state}</a>
      </div>
    );
  };

  const imageBodyTemplate = (rowData) => {
    let productsToShow = [];
    const product = productdata.find(
      (product) => product.id === rowData.productId,
    );
    if (rowData.products && rowData.products.length > 0) {
      productsToShow = rowData.products
        .slice(0, 2)
        .map((p) => productdata.find((product) => product.id === p.id));
    }

    return rowData?.products ? (
      <div
        onClick={() => navigateToOrder(rowData)}
        state={{
          from: { ...rowData },
          product: productdata.find(
            (product) => product.id === rowData.productId,
          ),
          products: productsToShow,
        }}
      >
        <div
          className={`flex overflow-hidden ${
            isRTL === "ltr"
              ? "-space-x-2 flex-row-reverse"
              : "-space-x-2 -space-x-reverse"
          }`}
        >
          {rowData.products.slice(0, 2).map((product, index) => (
            <div className="relative">
              {rowData.stayOffer && (
                <img
                  src="/sale.png"
                  alt={t("ui.sale")}
                  className="absolute top-0"
                  style={{
                    right: window.innerWidth <= 768 ? "31px" : "37px",
                    zIndex: 50,
                    maxWidth: window.innerWidth <= 768 ? "18px" : "20px",
                  }}
                />
              )}
              <div key={index} className="relative">
                {/* عرض الأيقونة فقط إذا كانت rowData.stayOffer موجودة */}
                <img
                  src={product?.image || "/product-foorweb.png"}
                  height="75px"
                  alt={product?.name}
                  className={`rounded-lg overflow-hidden shadow-sm border-2 border-white w-14 h-14 bg-[#faf1ff] z-30 avatar${
                    index + 1
                  }`}
                  style={{
                    border: rowData?.stayOffer
                      ? "2px solid #e91b24"
                      : rowData?.isImaginary
                        ? "2px solid #ffb400"
                        : "2px solid white",
                  }}
                />
                {/* صورة المنتج مع الإطار الأحمر */}
              </div>
              {rowData.isImaginary && (
                <img
                  src="/euror.png"
                  alt="559384"
                  className="absolute bottom-0 "
                  style={{
                    right: window.innerWidth <= 768 ? "27px" : "32px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
              {rowData.platform === "tiktok" && (
                <img
                  src="/tiktok.png" // حط لوجو تيك توك هنا
                  alt={t("navbar.try.tiktok")}
                  className="absolute top-0 right-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}

              {rowData.platform === "facebook" && (
                <img
                  src="/metaa.png" // حط لوجو ميتا/فيسبوك هنا
                  alt="Meta"
                  className="absolute top-0 left-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
            </div>
          ))}

          {rowData.products.length > 2 ? (
            <div className="relative">
              <div className="absolute top-0 left-0 text-white w-5 h-5 flex items-center justify-center rounded-full  bg-[#9b59bf] pt-1">
                {rowData.products.length > 2
                  ? `${rowData.products.length - 2}+`
                  : ""}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    ) : (
      <>
        {rowData.nameproduct ? (
          <Link
            to={`/orders/details`}
            state={{
              from: { ...rowData },
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={rowData.image ? rowData.image : "/product-foorweb.png"}
                  height="75px"
                  alt={rowData.nameproduct ? rowData.nameproduct : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        ) : (
          <Link
            to={`/orders/details`}
            state={{
              from: { ...rowData },
              product: productdata.filter(
                (product) => product.id === rowData.productId,
              )[0],
              products: productdata,
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={product ? product.image : "/product-foorweb.png"}
                  height="75px"
                  alt={product ? product.name : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        )}
      </>
    );
  };

  const hasValidOrders = selectedProducts.some(
    (product) => product.isValid === true,
  );

  const [showOptions, setShowOptions] = useState(false);
  const handleButtonClick = () => {
    setShowOptions(!showOptions);
  };

  const getUniqueDaysCount = (statusTimeline) => {
    if (!Array.isArray(statusTimeline)) return 0;

    const uniqueDates = new Set();

    statusTimeline.forEach((item) => {
      if (item.timestamp) {
        let timestamp = item.timestamp;

        if (timestamp.seconds) {
          timestamp = new Date(timestamp.seconds * 1000);
        } else if (isNaN(new Date(timestamp))) {
          return;
        } else {
          timestamp = new Date(timestamp);
        }

        const dayString = timestamp.toISOString().split("T")[0];
        uniqueDates.add(dayString);
      }
    });

    return uniqueDates.size;
  };

  const checkAndUpdateStatusAtMidnight = async (order) => {
    const tentativesCount = getUniqueDaysCount(order.statusTimeline);

    if (tentativesCount >= 3) {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      if (hours === 0 && minutes <= 1) {
        const lastUpdate = order.lastStatusUpdate
          ? new Date(order.lastStatusUpdate.seconds * 1000)
          : null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (!lastUpdate || lastUpdate < today) {
          await setDoc(doc(db, "orders", order.id), {
            ...order,
            deleveryStatus: "6",
            lastStatusUpdate: new Date(),
            statusTimeline: [
              ...(order.statusTimeline || []),
              {
                status: "6",
                timestamp: new Date(),
                ownby: "Automatique",
              },
            ],
          });
        }
      }
    }
  };

  const combinedTemplate = (rowData) => {
    const tentativesCount = getUniqueDaysCount(rowData.statusTimeline);
    let text = null;
    if (rowData.DC === "3") {
      text = translateCompanyDeliveryStatusEcotrack(
        rowData.CompanyDeleveryStatus,
      );
    } else if (rowData.DC === "1") {
      text = traduireStatutMaystro(rowData.CompanyDeleveryStatus);
    } else if (rowData.DC === "8") {
      text = getArabicStatusByIdZimou(rowData.CompanyDeleveryStatus);
    } else if (rowData.DC === "2") {
      text = rowData.CompanyDeleveryStatus;
    } else if (rowData.DC === "5") {
      text = rowData.CompanyDeleveryStatus;
    } else if (
      rowData.DC === "4" ||
      rowData.DC === "7" ||
      rowData.DC === "11" ||
      rowData.DC === "12" ||
      rowData.DC === "13"
    ) {
      text = t("ship.not_specified");
    }

    return (
      <Dropdown
        disabled={!(rowData.DC === "")}
        overlay={
          <Menu>
            {rowData.DC === "3" && (
              <Menu.Item
                key="99"
                className="ms-33 ss1 bi bi-repeat"
                onClick={() => runSync(true)}
              >
                <a className="s11">{t("ship.ecotrack_sync")}</a>
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <div className="relative inline-block">
          <button className="flex items-center justify-center px-4 py-2.5 rounded-lg border border-gray-300 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] hover:bg-gray-100 active:bg-gray-200 transition duration-150 mx-auto">
            <span className="text-sm font-medium text-gray-800 dark:!text-gray-300 w-[81px] ">
              {text}
            </span>
          </button>

          {tentativesCount > 0 && (
            <span className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center text-xs font-bold text-white bg-[#5a2b73] rounded-full shadow-md">
              {tentativesCount}
            </span>
          )}
        </div>
      </Dropdown>
    );
  };

  const trackship = (data) => {
    const [showPopup, setShowPopup] = React.useState(false);
    const buttonImage = "https://cdn-icons-png.flaticon.com/512/609/609361.png";

    const [isOpen, setIsOpen] = useState(false);
    const formatStatus = (status) => {
      return status
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    const handlePopup = (e) => {
      e.preventDefault();
      setShowPopup(!showPopup);
    };

    return (
      <div className="relative">
        {data.isValid ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{t("ship.send_tracking_link")}</Tooltip>}
          >
            <button
              className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] transition-colors active:bg-[#faf1ff] bot mx-auto"
              disabled
              onClick={handlePopup}
            >
              <img
                src={buttonImage}
                style={{ width: "20px" }}
                alt={t("ui.buttonIcon")}
              />
            </button>
          </OverlayTrigger>
        ) : (
          <div>
            <button
              className="flex items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] transition-colors active:bg-[#faf1ff] bot mx-auto"
              onClick={() => {
                const trackingStatus = data.tracking_status;
                if (trackingStatus) {
                  setIsOpen(true);
                }
              }}
              onMouseEnter={handlePopup}
              onMouseLeave={handlePopup}
            >
              <img
                src={buttonImage}
                style={{ width: "20px" }}
                alt={t("ui.buttonIcon")}
              />
            </button>
          </div>
        )}

        {showPopup && (
          <div className="absolute z-10 p-2 mt-1 text-sm bg-white border rounded-lg -right-4">
            {data.tracking_status ? (
              <p>
                {data.tracking_status[data.tracking_status.length - 1].status}
              </p>
            ) : (
              <p>{t("ship.no_tracking_number")}</p>
            )}
          </div>
        )}
      </div>
    );
  };

  const shippingOptions = [];
  /* ... Previous imports and code remain the same until the shippingOptions array ... */

  // Complete the shippingOptions array with translations
  if (!!store.Maystro)
    shippingOptions.push({ value: "1", label: t("services.foorCall.companies.maystro") });
  if (!!store.Zrexpress)
    shippingOptions.push({ value: "2", label: t("zr_express") });
  if (!!store.Ecotrack && !!store.Uecotrack)
    shippingOptions.push({ value: "3", label: t("services.foorCall.companies.ecotrack") });
  if (!!store.Userguid && !!store.ApitokenNord)
    shippingOptions.push({ value: "4", label: t("nord_et_ouest") });
  if (!!store.YalidineW && !!store.Yalidinetoken && !!store.Yalidineid)
    shippingOptions.push({ value: "5", label: t("services.foorCall.companies.yalidine") });
  if (!!store.UserguidGuepex && !!store.Apitokenguepex)
    shippingOptions.push({ value: "6", label: t("services.foorCall.companies.guepex") });
  if (!!store.apielogistia)
    shippingOptions.push({ value: "7", label: t("elogistia") });
  if (!!store.zimouUrl)
    shippingOptions.push({ value: "8", label: t("zimou_express") });
  if (!!store.AmeexId) shippingOptions.push({ value: "9", label: t("ameex") });
  if (!!store.mdm_apikey)
    shippingOptions.push({ value: "10", label: t("mdm_express") });
  if (!!store.YalitecId)
    shippingOptions.push({ value: "11", label: t("yalitec") });
  if (!!store.coliv_token)
    shippingOptions.push({ value: "12", label: t("colivraison") });

  return (
    <div className="datatable-templating-demo">
      {/* Order Actions Toolbar */}
      <div className="bg-white dark:!bg-[#181919] rounded-t-xl p-4 border-y border-purple-100 dark:!border-[#3c3a3d]">
        <div className="flex flex-wrap items-center gap-3">
          {/* Selected Orders Label */}
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-700 ml-2 dark:text-gray-300">
              {t("ship.selected_orders")}
            </span>
            <span className="bg-[#faf1ff] dark:bg-[#181919] text-[#9e68ba] px-2 py-0.5 rounded-md font-medium text-sm">
              {selectedProducts.length}
            </span>
          </div>

          {/* CSV Export Button */}
          <button
            disabled={selectedProducts.length < 1}
            className={`p-2 bg-white border dark:!bg-[#141414] ${
              selectedProducts.length < 1
                ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
            } rounded-lg transition-colors flex items-center gap-2`}
          >
            <CSVLink
              data={selectedProducts.map((p) => ({
                index: p.index,
                name: p.name,
                phone: p.isValid ? "***" : p.phone,
                state: p.state,
                commune: p.commune,
                address: p.address,
                product: p.nameproduct
                  ? p.nameproduct
                  : productdata.find((product) => product.id === p.productId)
                      ?.name || t("ship.product"),
                options: p.options,
                qty: p.qty,
                deleveryPrice: p.deleveryPrice,
                total: p.total,
                sku: p.sku,
              }))}
              headers={[
                { label: t("orders.order_number"), key: "index" },
                { label: t("ship.full_name"), key: "name" },
                { label: t("ship.phone_number"), key: "phone" },
                { label: t("orders.state"), key: "state" },
                { label: t("orders.sheetabndnConfig.columnsLabels.commune"), key: "commune" },
                { label: t("orders.sheetabndnConfig.columnsLabels.address"), key: "address" },
                { label: t("ship.product"), key: "product" },
                { label: t("orders.options"), key: "options" },
                { label: t("ship.quantity"), key: "qty" },
                { label: t("orders.delivery_price"), key: "deleveryPrice" },
                { label: t("ship.total"), key: "total" },
                { label: t("sku"), key: "sku" },
              ]}
              filename={t("ship.orders_export_filename")}
              className={
                selectedProducts.length < 1 ? "pointer-events-none" : ""
              }
            >
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`${
                    selectedProducts.length < 1
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }`}
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span
                  className={`${
                    selectedProducts.length < 1
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  } text-sm font-medium`}
                >
                  {t("ship.export")}
                </span>
              </div>
            </CSVLink>
          </button>
          <iframe
            id="pdfPrinter"
            style={{ display: "none" }}
            title={t("ship.pdf_printer_title")}
          />

          {/* Print Button */}
          <button
            disabled={selectedProducts.length < 1}
            onClick={handleLabels}
            className={`p-2 bg-white border dark:!bg-[#141414] ${
              selectedProducts.length < 1
                ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
            } rounded-lg transition-colors flex items-center gap-2`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`${
                selectedProducts.length < 1 ? "text-gray-400" : "text-[#9e68ba]"
              }`}
            >
              <polyline points="6 9 6 2 18 2 18 9" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
            <span
              className={`${
                selectedProducts.length < 1 ? "text-gray-400" : "text-[#9e68ba]"
              } text-sm font-medium`}
            >
              {t("orders.datatable_templating_demo.print")}
            </span>
          </button>

          {/* Sync Button */}
          <div className="relative">
            <button
              onClick={async () => await syncCompany()}
              disabled={chargement}
              className={`p-2 bg-white border dark:!bg-[#141414] ${
                chargement
                  ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                  : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
              } rounded-lg transition-colors flex items-center gap-2`}
            >
              {chargement ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="animate-spin text-[#9e68ba]"
                  style={{ animationDuration: "2s" }}
                >
                  <path d="M21 2v6h-6" />
                  <path d="M3 22v-6h6" />
                  <path d="M3.51 9a9 9 0 0114.13-3.36L21 8" />
                  <path d="M20.49 15a9 9 0 01-14.13 3.36L3 16" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="ml-2 text-[#9e68ba]"
                >
                  <path d="M21 2v6h-6" />
                  <path d="M3 22v-6h6" />
                  <path d="M3.51 9a9 9 0 0114.13-3.36L21 8" />
                  <path d="M20.49 15a9 9 0 01-14.13 3.36L3 16" />
                </svg>
              )}
              <span className="text-[#9e68ba] text-sm font-medium">
                {t("ship.update")} {hasValidOrders ? t("ship.valid_orders") : ""}
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="">
        <style>{darkModeStyles}</style>
        <DataTable
          value={
            !!filter
              ? orders.filter(
                  (order) =>
                    order.index
                      .toString()
                      .toLowerCase()
                      .includes(filter.toLowerCase()) ||
                    order.name.toLowerCase().includes(filter.toLowerCase()) ||
                    order.phone.toLowerCase().includes(filter.toLowerCase()),
                )
              : _DATA.currentData()
          }
          responsiveLayout="scroll"
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          emptyMessage={t("ship.no_results_found")}
          rowClassName={(rowData, rowIndex) =>
            rowIndex % 2 === 0 ? "p-row-odd" : "p-row-even"
          }
        >
          <Column
            header={
              <Form.Check
                type={"checkbox"}
                checked={selectedProducts.length === _DATA.currentData().length}
                onChange={() => {
                  selectedProducts.length === _DATA.currentData().length
                    ? setSelectedProducts([])
                    : setSelectedProducts([..._DATA.currentData()]);
                }}
              />
            }
            className="text-end"
            body={selectTemplate}
            style={{ width: "3rem" }}
          ></Column>
          <Column
            header={t("ship.product")}
            className="text-end"
            body={imageBodyTemplate}
          ></Column>
          <Column
            body={customerName}
            field="name"
            className="text-end n-name"
            header={t("ship.customer")}
          ></Column>
          <Column
            field={notPaidTemplate}
            className="text-end n-phone"
            header={t("ship.phone_number")}
          ></Column>
          <Column
            body={dateBodyTemplate}
            className="text-end n-date"
            header={t("ship.order_date")}
          ></Column>
          <Column
            body={deleveryBodyTemplate}
            className="text-end n-date"
            header={t("ship.delivery_company")}
          ></Column>
          <Column
            field={wilaya1}
            className="text-end n-wilaya"
            header={
              store.country === "الجزائر"
                ? t("ship.wilaya")
                : store.country === "مصر"
                  ? t("ship.governorate")
                  : t("orders.state")
            }
          ></Column>
          <Column
            style={{ minWidth: "125px" }}
            header={t("ship.order_status")}
            className="text-end n-status1"
            body={combinedTemplate}
          ></Column>
          <Column
            style={{ color: "#6e4881" }}
            body={orderTotal}
            className="text-end n-total"
            header={t("ship.total")}
          ></Column>
          <Column
            expander
            style={{ width: "0em" }}
            className="dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          />
        </DataTable>
      </div>

      <div className="d-flex justify-content-center py-3 dark:bg-[#181819]">
        {
          <Stack spacing={2} dir="ltr">
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000",
                  borderColor: isDark ? "#a065c0" : "#ccc",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                },
              }}
            />
          </Stack>
        }
      </div>
      <div className="hidden">
        <ComponentToPrint
          ref={componentRef}
          data={selectedProducts}
          store={store}
          account={account}
          products={productdata}
        />
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
